module.exports = __webpack_public_path__ + "media/images/front/popular_contents_02-45ded9c6257a9e40c72c7b85d7b5f88f.jpg";